import { useState } from "react";
import axios, { API } from "../../api";

/**
 * Account deletion confirmation. Requires typing DELETE to prevent fat-finger taps.
 * On confirm, calls DELETE /api/auth/me which purges all user data, then logs out.
 */
export function DeleteAccountModal({ onClose, onDeleted }) {
  const [confirmText, setConfirmText] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState("");
  const canDelete = confirmText.trim().toUpperCase() === "DELETE";

  const handleDelete = async () => {
    if (!canDelete) return;
    setError("");
    setDeleting(true);
    try {
      await axios.delete(`${API}/auth/me`);
      onDeleted?.();
    } catch (e) {
      setError(e?.response?.data?.detail || "Couldn't delete account. Please email support.");
      setDeleting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="delete-account-modal" onClick={(e) => e.stopPropagation()} data-testid="delete-account-modal">
        <div className="delete-emoji">⚠️</div>
        <h2>Delete your Aura forever?</h2>
        <p className="delete-warning">
          This permanently removes everything Aura knows about you — your conversations,
          wallpapers, the people Aura remembers, every letter she's written you.
          We cannot undo this.
        </p>
        <p className="delete-warning subtle">
          If you have an active premium subscription, please cancel it first
          (Settings → Manage subscription) so you're not charged again.
        </p>

        <label className="delete-label">
          Type <strong>DELETE</strong> to confirm
        </label>
        <input
          type="text"
          className="init-input"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          placeholder="DELETE"
          autoComplete="off"
          data-testid="delete-confirm-input"
        />

        {error && <div className="error-message">{error}</div>}

        <button
          className="delete-btn"
          onClick={handleDelete}
          disabled={!canDelete || deleting}
          data-testid="delete-confirm-btn"
        >
          {deleting ? "Deleting..." : "Delete my account forever"}
        </button>
        <button
          className="ghost-btn small"
          onClick={onClose}
          data-testid="delete-cancel-btn"
          style={{ marginTop: "0.5rem" }}
        >
          Keep my account
        </button>
      </div>
    </div>
  );
}
